<template>
  <div class="auto_css">
    <div class="z_img">
      <el-image class="imgw145 imgbg" :src="require('@/assets/ztop.jpg')" />
    </div>
    <div class="us_bg">
      <div class="w1200">
        <div class="title">
          <!-- <el-image
            class="imgw145"
            :src="autoimgyn == 'en' ? gametitleen : gametitle"
          /> -->
          <p class="icontitle_p1">{{ data.name || "CCCC名字" }}</p>
        </div>
        <div class="contetn">
          <div class="gamecont pr">
            <div class="gametitle">
              <div class="gametitle_left">
                <span class="gameicon">
                  <el-image
                    class="imgw145"
                    :src="require(`@/assets/${data.tag}/ICON.png`)"
                  />
                </span>
                <div class="icontitle">
                  <p>{{ data.gameType }}</p>
                  <p>
                    {{
                      data.describe ||
                      "游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍游戏介绍"
                    }}
                  </p>
                </div>
              </div>
              <div class="gametitle_right">
                <el-image
                  class="imgw145 btnimg"
                  :src="require('@/assets/iosdd.png')"
                  @click="handleDownload('1')"
                />
                <el-image
                  class="imgw145 btnimg"
                  :src="require('@/assets/aidd.png')"
                  @click="handleDownload('2')"
                />
              </div>
            </div>
            <div class="five">
              <ul>
                <li>
                  <div class="pr-img">
                    <el-image
                      class="imgw145"
                      :src="require(`@/assets/${data.tag}/1.jpg`)"
                    />
                    <!-- <span class="pa">游戏名字</span> -->
                  </div>
                </li>
                <li>
                  <div class="pr-img">
                    <el-image
                      class="imgw145"
                      :src="require(`@/assets/${data.tag}/2.jpg`)"
                    />
                  </div>
                </li>
                <li>
                  <div class="pr-img">
                    <el-image
                      class="imgw145"
                      :src="require(`@/assets/${data.tag}/3.jpg`)"
                    />
                  </div>
                </li>
                <li>
                  <div class="pr-img">
                    <el-image
                      class="imgw145"
                      :src="require(`@/assets/${data.tag}/4.jpg`)"
                    />
                  </div>
                </li>
                <li>
                  <div class="pr-img">
                    <el-image
                      class="imgw145"
                      :src="require(`@/assets/${data.tag}/5.jpg`)"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: `ContactUs`,
  setup() {
    const gametitle = require("@/assets/gametitle.png");
    const gametitleen = require("@/assets/en/gametitle.png");
    const autoimgyn = sessionStorage.getItem("lang");

    const url = window.location.href;
    const arr = url.split("id=");
    const id = arr[1];
    const data = ref();

    if (id == "luandou") {
      data.value = {
        tag: "luandou",
        name: "Hyperdimension Fight",
        gameType: "Anime Idle RPG Game",
        iosUrl:
          "https://apps.apple.com/us/app/hyperdimension-fight/id6449516668",
        googleUrl:
          "https://play.google.com/store/apps/details?id=com.xinshengfun.ldlm.en",
        describe:
          "Popular anime characters gather for a chaotic battle! Join this brand-new gaming world and fight with your favorite IP characters! Play the best Anime Idle RPG game to get all you want!",
      };
    } else if (id == "ariems") {
      data.value = {
        tag: "ariems",
        name: "Legend Of Dim Artemis",
        gameType: "MMORPG Game",
        iosUrl: "",
        googleUrl: "",
        describe:
          "Epic-like World, Wonderful Adventure. Choose to become warriors, mages and inhumans and start your own adventures! Defeat bosses scattering around Element Land to establish your own empire.",
      };
    }

    const handleDownload = (type) => {
      if (type === "1") {
        // ios
        if (!data.value.iosUrl) return;
        window.open(data.value.iosUrl);
      } else if (type === "2") {
        // 谷歌
        if (!data.value.googleUrl) return;
        window.open(data.value.googleUrl);
      }
    };

    return { gametitleen, gametitle, autoimgyn, data, handleDownload };
  },
};
</script>

<style lang="less" scoped>
.gameicon {
  background: url("../../../src/assets/gameiconk.png");
  width: 170px;
  height: 170px;
  padding: 15px;
  display: inline-block;
  float: left;
}
.icontitle {
  width: 500px;
  float: left;
}
.gametitle {
  height: 250px;
}
.icontitle p {
  margin-top: 10px;
  margin-left: 50px;
  font-size: 20px;
  line-height: 35px;
}
.icontitle p.icontitle_p1 {
  font-size: 30px;
  font-weight: bold;
}
.title {
  margin-bottom: 20px;
}
.icontitle_p1 {
  font-size: 35px;
  color: #fff;
  font-weight: 700;
}
.gametitle_right {
  float: right;
  width: 290px;
}
.btnimg {
  margin-bottom: 15px;
}
.five {
  ul {
    li {
      width: 210px;
      height: 373px;
    }
  }
}
</style>
